import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonIcon, IonBackButton } from '@ionic/react'
import { eye } from 'ionicons/icons'

const Documentation = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Documentation</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent class='ion-padding'>
                <h1 className='text ion-text-lg-center'>GETTING STARTED</h1>

                <h4>1. SETTING UP COMPANY</h4>
                <ul>
                    <li><h6>1.1. Click on <i className='red-text'>Company</i> button  </h6></li>
                    <li><h6>1.2. Click on <i className="red-text">Edit</i> button</h6></li>
                    <li><h6>1.3. Enter the Company Details and click <i className="red-text">Done</i> .</h6></li>
                </ul>

                <h4>2. CREATE BILL</h4>
                <ul>
                    <li><h6>2.1. Click on <i className='red-text'>Create Invoice</i> button  </h6></li>
                    <li><h6>2.2. Enter the Customer Details and Product Items and click <i className="red-text">Generate Bill</i> to create invoice.</h6></li>
                    <li>
                        <h6>2.3 In order to create GST invoice, go to settings and click on <i className="red-text">Enable GST</i> button.</h6>
                    </li>
                    <li>
                        <h6>
                            2.4. Once the invoice is generated, you can print the invoice by clicking on <i className="red-text">Print</i> button.
                        </h6>
                    </li>

                </ul>

                <h4>3. VIEW BILL</h4>
                <ul>
                    <li><h6>3.1. Click on <i className='red-text'>Invoices</i> button  </h6></li>
                    <li><h6>3.2. Search by Customer Name , Invoice No. or Date  and click <IonIcon icon={eye} className="red-text">remove_red_eye</IonIcon> to view invoice.</h6></li>
                    <li><h6>3.3. Click on <i className="red-text">Print</i> button to print the invoice.</h6></li>
                    <li><h6>3.4. Click on <i className="red-text">Delete</i> button to delete the invoice.</h6></li>
                </ul>
                <h4>4. VIEW LEDGER / CUSTOMER ACCOUNT </h4>
                <ul>
                    <li><h6>4.1. Click on <i className='red-text'>Customer Ledger</i> button  </h6></li>
                    <li><h6>4.2. Search by Customer Name and click <i className="red-text">Customer Name</i> to view Customer Details.</h6></li>
                    <li><h6>4.3. You can add amount (Credit or Debit) to the Customer Account Details.</h6></li>
                </ul>
            </IonContent>
        </IonPage>
    )
}

export default Documentation

